import { render, staticRenderFns } from "./GraficoProdutividadeMedia.vue?vue&type=template&id=1cdcbda5&scoped=true&lang=pug"
import script from "./GraficoProdutividadeMedia.vue?vue&type=script&lang=js"
export * from "./GraficoProdutividadeMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdcbda5",
  null
  
)

export default component.exports